import { useTranslation } from "react-i18next";
import { IStudentCountByRegionContent } from "src/app/services/tables/type";
import { useGetTablesStudentCountByRegionQuery } from "src/app/services/tables";
import type { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { ConfigProvider, Select, Space, Table } from "antd";
import { DownloadButton } from "src/components/downloadButton";
import { useGetUniversityOwnershipCodesQuery } from "src/app/services/private";

export function TablesStudentCountByRegion() {
  const { t } = useTranslation();
  const [ownershipCode, setOwnershipCode] = useState();
  const [eduType, setEduType] = useState();
  const { data, isFetching } = useGetTablesStudentCountByRegionQuery({
    ownershipCode,
    eduTypeCode: eduType,
  });
  const { data: universityOwnershipCodes } =
    useGetUniversityOwnershipCodesQuery();

  const edu_type_list = [
    {
      value: "11",
      label: "Bakalavr",
    },
    {
      value: "12",
      label: "Magistr",
    },
    {
      value: "13",
      label: "Ordinatura",
    },
  ];

  const columns: ColumnsType<IStudentCountByRegionContent> = [
    {
      title: t("prof.region_name"),
      dataIndex: "region",
    },
    {
      title: t("genders.women"),
      dataIndex: "maleCount",
    },
    {
      title: t("genders.men"),
      dataIndex: "femaleCount",
    },
    {
      title: t("tables.total"),
      dataIndex: "total",
      align: "center",
      render: (total) => <b>{total}</b>,
    },
  ];

  return (
    <div>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              rowSelectedBg: "#e6f4ff",
              rowSelectedHoverBg: "#bae0ff",
            },
          },
        }}
      >
        <Table
          title={() => (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3>{t("tables.studentCountByRegion")}</h3>

              <Space>
                <Select
                  style={{ width: 230 }}
                  onChange={setEduType}
                  placeholder="Ta'lim turi"
                  value={eduType}
                  options={edu_type_list}
                  allowClear={true}
                  onClear={() => setEduType(undefined)}
                />

                <Select
                  style={{ width: 200 }}
                  onChange={setOwnershipCode}
                  placeholder="Mulkchilik shakli"
                  value={ownershipCode}
                  options={universityOwnershipCodes?.map((item) => ({
                    value: item.code,
                    label: item.name,
                  }))}
                  onClear={() => setOwnershipCode(undefined)}
                  allowClear={true}
                />

                <DownloadButton
                  downloadUrl="/excel/student/regionAndGender"
                  params={{
                    eduTypeCode: eduType && eduType,
                    ownershipCode: ownershipCode && ownershipCode,
                  }}
                />
              </Space>
            </div>
          )}
          rowKey="region"
          dataSource={data}
          columns={columns}
          pagination={false}
          rowSelection={{ type: "radio", columnWidth: 80 }}
          size="small"
          scroll={{ x: true, y: 550 }}
          loading={isFetching}
        />
      </ConfigProvider>
    </div>
  );
}
